import * as t from 'io-ts';

export const optional = <CS extends t.Mixed>(codec: CS): t.UnionC<[CS, t.UndefinedC, t.NullC]> =>
    t.union([codec, t.undefined, t.null]);
